import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { isHit99, isBet99ex, isMax365, isDeva99, getCodeTheme, getBaseDomain, getResolvedApiBaseUrl, getSiteName, getDomainLogo } from './utils/domainConfig'
import { THEME_KEYS } from './config/siteThemes'

document.documentElement.setAttribute('data-brand', isHit99() ? 'hit99' : isBet99ex() ? 'bet99ex' : isMax365() ? 'max365' : isDeva99() ? 'deva99' : 'default')

// Theme: "Site Theme" page se domain-wise (backend AppUrl.theme). Pehle cache/code (flash na ho), phir backend se taaza.
const KNOWN_THEMES = THEME_KEYS
// data-theme = palette, data-skin = skin layout (default pe nahi)
const setTheme = (t) => {
  const root = document.documentElement
  root.setAttribute('data-theme', t)
  if (t && t !== 'default') root.setAttribute('data-skin', '')
  else root.removeAttribute('data-skin')
}
let cachedTheme = null
try { cachedTheme = localStorage.getItem('site_theme') } catch { /* ignore */ }
setTheme(KNOWN_THEMES.includes(cachedTheme) ? cachedTheme : getCodeTheme())
{
  const apiBase = getResolvedApiBaseUrl(import.meta.env.VITE_API_BASE_URL || '').replace(/\/$/, '')
  const ctrl = new AbortController()
  setTimeout(() => ctrl.abort(), 4000)
  fetch(`${apiBase}/api/appurls/theme?domain=${encodeURIComponent(getBaseDomain())}`, { signal: ctrl.signal })
    .then((r) => (r.ok ? r.json() : null))
    .then((d) => {
      const t = d?.theme
      if (!KNOWN_THEMES.includes(t)) return // backend me abhi field nahi -> code wali chalegi
      try { localStorage.setItem('site_theme', t) } catch { /* ignore */ }
      if (document.documentElement.getAttribute('data-theme') !== t) {
        setTheme(t)
        window.dispatchEvent(new Event('site-theme-change'))
      }
    })
    .catch(() => {})
}
document.title = `${getSiteName()} Admin`
const favicon = document.getElementById('favicon')
// max365: client wala favicon (bats icon) — chauda logo tab me pichak jaata tha (2026-10-25)
if (favicon) favicon.href = isMax365() ? '/favicon-max365.png' : isDeva99() ? '/favicon-deva99.png' : getDomainLogo()
// DEVA99: WhatsApp / social share image + apple-touch-icon (2026-11-01)
if (isDeva99()) {
  const origin = typeof window !== 'undefined' ? window.location.origin : ''
  const og = origin + '/deva99-og.png'
  const setMeta = (sel, v) => { const m = document.querySelector(sel); if (m) m.setAttribute('content', v) }
  setMeta("meta[property='og:title']", 'DEVA99 Admin')
  setMeta("meta[property='og:description']", 'Casino . Sports . Live')
  setMeta("meta[property='og:image']", og)
  setMeta("meta[name='twitter:title']", 'DEVA99 Admin')
  setMeta("meta[name='twitter:image']", og)
  const apple = document.querySelector("link[rel='apple-touch-icon']"); if (apple) apple.href = '/favicon-deva99.png'
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
